import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import StudentReport from '../admin/components/StudentReport.js';

function Component(props) {
       const navigate = useNavigate();
       const mission = props.mission
   
   

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap px-[16px] pt-[16px] mb-[8px]'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { 
                    navigate(`/edb1/missions`) }}>{`<`} 返回</div>
            </div>
            <div className='w-full'>
                <StudentReport mission={mission} isPublic={true}/>
            </div>
  
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
